var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    ref: "trigger"
  }, [_vm._t("default"), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.effect
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show && _vm.popoverCondition),
      expression: "show && popoverCondition"
    }],
    ref: "popover",
    class: ['popover', _vm.placement, _vm.classes],
    style: (_vm.popoverStyle),
    attrs: {
      "id": _vm.id
    }
  }, [_c('div', {
    staticClass: "arrow",
    style: (_vm.arrowStyle)
  }), _vm._v(" "), (_vm.title) ? _c('h3', {
    staticClass: "popover-title",
    style: (_vm.textStyle)
  }, [_vm._t("title", [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.ok_close
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "18",
      "height": "18",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z",
      "fill": "#292c34"
    }
  })])])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "popover-content",
    style: (_vm.textStyle)
  }, [_vm._t("content", [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 2), _vm._v(" "), _c('div', [(_vm.showNO) ? _c('button', {
    staticClass: "btn btn-danger btn-sm",
    staticStyle: {
      "float": "left",
      "margin": "5px"
    },
    on: {
      "click": _vm.no_close
    }
  }, [_vm._v(_vm._s(_vm.no_text))]) : _vm._e(), _vm._v(" "), (_vm.showOK) ? _c('button', {
    staticClass: "btn btn-primary-default btn-sm",
    staticStyle: {
      "float": "right",
      "margin": "5px"
    },
    on: {
      "click": _vm.ok_close
    }
  }, [_vm._v(_vm._s(_vm.ok_text))]) : _vm._e()])])])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ebae903","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dynamic/popoverWrapper/Popover.vue
// module id = 1371
// module chunks = 1